import { CompanyTagCategory } from "@prisma/client";
import HttpStatus from "http-status-codes";
import { type NextApiHandler } from "next";
import { type ApiRoute } from "~/hooks/useApi";
import { api } from "~/lib/api";
import { createQuery } from "~/lib/reactQuery";
import { listCompanyTags, type ListCompanyTagsResult } from "~/services/company-tags/listCompanyTags";

const handler: NextApiHandler<ListCompanyTagsResult> = async (req, res) => {
  const allCachedTags = await listCompanyTags(req);

  if (!req.user?.isSuperAdmin) {
    if (!req.featureFlags.CAN_ACCESS_BIG_FOUR_LABEL) {
      const withoutBigFourTags = allCachedTags.filter((tag) => tag.category !== CompanyTagCategory.INTERNAL_BENCHMARK);
      const withoutInternalTags = withoutBigFourTags.filter((tag) => tag.category !== CompanyTagCategory.INTERNAL);
      return res.status(HttpStatus.OK).json(withoutInternalTags);
    }

    const withoutInternalTags = allCachedTags.filter((tag) => tag.category !== CompanyTagCategory.INTERNAL);
    return res.status(HttpStatus.OK).json(withoutInternalTags);
  }

  return res.status(HttpStatus.OK).json(allCachedTags);
};

export default api(handler, {
  method: "POST",
  authentication: { optional: true },
});

export const LIST_COMPANY_TAGS_QUERY_KEY: ApiRoute["pathname"] = "/api/list-company-tags";

export const useListCompanyTagsQuery = createQuery<typeof handler>({
  path: LIST_COMPANY_TAGS_QUERY_KEY,
});
